// METIS Hub wording — namespace "app" (en): product wording that the mockup does not have (hand-written). See ko/app.ts.
const app: Record<string, string> = {
  "notif.grant_dormant.title": "A permission has been unused for 90 days",
  "notif.grant_dormant.body": "Review whether it is still needed, then keep or revoke it.",
  "notif.grant_expiry_deferred.title": "The last administrator’s expiry was deferred",
  "notif.grant_expiry_deferred.body": "Assign another administrator, then arrange reapproval of the existing administrator’s grant.",

  "audit.detail.role_names": "{roles} · {teams}",
  "audit.detail.policy_change": "{path} · {from} → {to}",
  "event.user_prompt": "Question entered",
  "event.answer": "AI answer",
  "event.assistant_response": "AI answer",
  "event.api_request": "AI request",
  "event.api_error": "AI request error",
  "event.api_retries_exhausted": "Request retries exhausted",
  "event.api_refusal": "AI request refused",
  "event.tool_decision": "Tool decision",
  "event.tool_result": "Tool result",
  "event.content_view": "Content viewed",
  "event.permission_mode_changed": "Permission mode changed",
  "event.subagent_completed": "Subagent completed",
  "event.skill_activated": "Skill activated",
  "event.compaction": "Conversation compacted",
  "event.auth": "Authentication",
  "event.internal_error": "Internal error",
  "event.mcp_server_connection": "Tool server connection",
  "event.plugin_installed": "Plugin installed",
  "event.plugin_loaded": "Plugin loaded",
  "event.hook_execution_start": "Hook started",
  "event.hook_execution_complete": "Hook completed",
  "event.managed_settings_resolved": "Managed settings applied",
  "event.hook_registered": "Hook registered",
  "event.conversation_starts": "Conversation started",
  "event.agent_response": "AI answer",
  "event.websocket_request": "Connection request",
  "event.websocket_connect": "Live connection",
  "event.sse_event": "Response received",
  "event.websocket_event": "Response received",
  "event.sandbox_outcome": "Sandbox result",
  "event.turn_cost": "Turn cost",
  "event.turn_ttft": "First response wait",
  "event.startup_phase": "Startup phase",
  "event.auth_recovery": "Authentication recovery",
  "event.plugin_install": "Plugin installation",
  "event.guardian": "Execution protection check",
  "event.other": "Other event",
  "audit.detail.retention_window": "{setting} · {from} days → {to} days",
  "people.export.pseudonyms": "People appear as pseudonyms. Names and question or answer text are excluded.",
  "admin.policy.envLocks": "{n} settings are locked by server configuration",
  "admin.preview.otherRoles": "Holders with other roles",
  "me.adv.workRiskTitle": "Record work details?",
  "me.adv.workRiskBody": "Commands and tool inputs may contain passwords or secret keys. Redaction runs before storage, but cannot detect every secret.",
  "me.adv.workRiskCheck": "I understand this risk and agree to record work details.",
  "admin.price.confirmedAt": "Price verification date",
  "me.ds.tzDefault": "Use company time zone",
  // Insights (SCR-05) — names of contract-only values, sharing saved views by link, failure notices
  "stats.m.retries": "Retries",
  "stats.person.pseudonym": "User #{code}",
  "stats.effort.max": "Max",
  "stats.decision.abort": "Closed without an answer",
  "stats.decision.timed_out": "Timed out",
  "stats.errorKind.auth": "Authentication error",
  "stats.errorKind.client_error": "Request error (4xx)",
  "stats.errorKind.network": "Network error",
  "stats.errorKind.timeout": "Timed out",
  "stats.errorKind.interrupted": "Interrupted",
  "stats.errorKind.policy_rejected": "Blocked by policy",
  "stats.views.link": "Share by link",
  "stats.views.linkDesc": "Anyone with the link can open it, re-checked against their own permissions and view scope.",
  "stats.views.linkOn": "Shared by link",
  "stats.views.copyLink": "Copy link",
  "stats.views.edit": "Edit",
  "stats.views.editTitle": "Edit this saved view?",
  "stats.views.updated": "Updated the view “{name}”",
  "stats.views.fail": "Couldn’t change the saved view. Try again.",
  "stats.views.loadFail": "Couldn’t load your saved views.",
  "stats.export.fail": "Couldn’t export. Try again.",
  "stats.export.rowLimit": "Too many rows to export. Narrow the period or the conditions.",
  "stats.export.previewNote": "The preview is built from this card’s table. The file itself is made by the server and sent straight to you.",
  // Collection status (SCR-14) — contract reason codes (dropped, refused, gaps, connection problems), jobs and checks
  "admin.sys.c1.refused": "Refused before reading",
  "admin.sys.drop.no_consent": "Before consent",
  "admin.sys.drop.before_consent": "Sent before consent",
  "admin.sys.drop.notice_outdated": "Re-consent to the notice needed",
  "admin.sys.drop.withdrawn": "Consent withdrawn",
  "admin.sys.drop.paused": "Paused",
  "admin.sys.drop.inside_pause_window": "Sent while paused",
  "admin.sys.drop.store_off": "Storage off",
  "admin.sys.drop.ingest_disabled": "Company collection off",
  "admin.sys.drop.undeterminable_time": "Unknown or future time",
  "admin.sys.drop.older_than_retention": "Older than the retention period",
  "admin.sys.drop.parse_error": "Format error",
  "admin.sys.drop.no_session": "No conversation number",
  "admin.sys.drop.unknown_event": "Unknown record (name and count only)",
  "admin.sys.drop.excluded_by_policy": "Not stored by policy",
  "admin.sys.drop.noise": "Counted only",
  "admin.sys.drop.level_off": "Outside the recording level",
  "admin.sys.rej.no_token": "No connection token",
  "admin.sys.rej.bad_token": "Wrong connection token",
  "admin.sys.rej.revoked": "Revoked connection token",
  "admin.sys.rej.expired": "Expired connection token",
  "admin.sys.rej.legacy_header": "Old PoC settings",
  "admin.sys.rej.browser_origin": "Sent from a browser",
  "admin.sys.rej.rate_limited": "Sent too often",
  "admin.sys.rej.busy": "Server busy",
  "admin.sys.rej.too_large": "Too large",
  "admin.sys.rej.bad_format": "Bad format",
  "admin.sys.gapReason.server_unreachable": "Couldn’t reach the server",
  "admin.sys.gapReason.no_receipt": "Nothing received (reason unknown)",
  "admin.sys.gapReason.helper_silent": "PC helper silent",
  "admin.sys.gapReason.restore": "Restoring",
  "admin.sys.gapReason.maintenance": "Maintenance",
  "admin.sys.issue.no_records": "No records arriving",
  "admin.sys.issue.helper_not_responding": "The PC helper isn’t responding",
  "admin.sys.issue.helper_backlog": "Unsent records piled up in the PC helper",
  "admin.sys.issue.collect_token_expired": "The connection token expired",
  "admin.sys.issue.collect_token_revoked": "The connection token was revoked",
  "admin.sys.issue.legacy_settings": "Old PoC settings remain",
  "admin.sys.issue.sends_more_than_consent": "Settings send more than the consent allows",
  "admin.sys.issue.version_old": "Older than the supported version",
  "admin.sys.issue.version_checking": "Checking the new version",
  "admin.sys.c4.issue.late": "The report is late",
  "admin.sys.c4.issue.auth": "The Admin key was refused",
  "admin.sys.c4.issue.rate_limited": "Hit the request limit",
  "admin.sys.c4.issue.no_admin_key": "No Admin key",
  "admin.sys.c4.notConnected": "Not connected yet",
  "admin.sys.c4.syncProgress": "Syncing the org usage reports ({done}/{total})",
  "admin.sys.c4.syncFailed": "Sync failed · error {code}",
  "admin.sys.c3.offWhat": "The API gateway isn’t on yet.",
  "admin.sys.c2.sumOn": "{p} of {n} pilot devices have errors.",
  "admin.sys.job.running": "Running",
  "admin.sys.job.ok": "Done",
  "admin.sys.job.partial": "Partly done",
  "admin.sys.job.error": "Error",
  "admin.sys.job.skipped": "Skipped",
  "admin.sys.job.schedule": "Scheduled",
  "admin.sys.job.manual": "Run by hand",
  "admin.sys.job.deleted": "{n} deleted",
  "admin.hl.sumWarn": "{n|run unit needs|run units need} a look. Storage {p} used.",
  "admin.hl.beat": "Last signal {rel}",
  "admin.hl.stopped": "Stopped",
  "admin.hl.diag": "Settings check",
  "admin.hl.diagSet": "Set",
  "admin.hl.diagMissing": "Missing",
  "admin.hl.diagNote": "Values are never shown — only whether each setting exists.",
  // Cost policy (SCR-15) — contract price cells (cache write 5 min / 1 h, long context) and save failure
  "admin.kinds.basisCalls": "{n|call|calls}",
  "admin.price.techLive": "Price table · price versions · USD per 1M tokens",
  "admin.price.col.cacheWrite5m": "Saved to cache (5 min)",
  "admin.price.col.cacheWrite1h": "Saved to cache (1 h)",
  "admin.price.long": "Long context: over {n} tokens, input {in} · output {out}",
  "admin.price.errSave": "Couldn’t schedule the price version. Try again.",
  "login.googleHintPlain": "Only company Google accounts can sign in.",
  "login.gerr.domainPlain": "This isn’t a company-domain account. Try again with your company Google account.",
  "login.err.wrongPlain": "The user ID or password is incorrect.",
  "login.expired": "Your sign-in ended. Please sign in again.",
  "login.loggedOut": "You signed out.",
  "login.mfa.errWrong": "That code isn’t right. Enter it again.",
  "login.gate.pw.current": "Current password (temporary)",
  "login.gate.pw.errCurrent": "The current password is incorrect.",
  "login.gate.pw.errServer": "The password couldn’t be changed. Check the rules and try again.",
  "login.setup.kicker": "First-time setup · first admin",
  "login.setup.title": "Create the first admin",
  "login.setup.desc": "There are no users yet. Enter the one-time setup code from the server’s data folder and create the first admin account.",
  "login.setup.code": "One-time setup code",
  "login.setup.codeHint": "It’s in a file only the installer can read, and it works only once.",
  "login.setup.displayName": "Name",
  "login.setup.email": "Email",
  "login.setup.submit": "Create admin",
  "login.setup.busy": "Creating…",
  "login.setup.done": "The first admin is ready. Sign in with the new account.",
  "login.setup.err.required": "Fill in every field.",
  "login.setup.err.email": "Enter a valid email address.",
  "login.setup.err.code": "The setup code is wrong or has already been used.",
  // People & teams (SCR-06) · person page (SCR-07) · team page — contract-only actions (accounts, teams, sign-ins, undo, errors)
  "people.pseudonym": "User #{code}",
  "people.save": "Save",
  "people.reasonOpt": "Reason (optional)",
  "people.create.btn": "Add person",
  "people.create.title": "Add a person",
  "people.create.kicker": "New account",
  "people.create.name": "Name",
  "people.create.method": "Sign-in method",
  "people.create.method.password": "User ID · temporary password",
  "people.create.method.google": "Google account only",
  "people.create.loginId": "User ID",
  "people.create.loginIdHint": "3–64 characters: letters, digits, . _ or -.",
  "people.create.googleHint": "They sign in only with the company Google account of this email. No password is made.",
  "people.create.roleHint": "Choose an initial role within your authority. The member role is always retained.",
  "people.create.roleTeams": "Teams for this role",
  "people.create.approvalHint": "This role requires another reviewer’s approval. The account starts as a member until approved.",
  "people.inv.roleNotApplied": "Initial role not applied · {status}",
  "people.inv.approval": "Approval request {code} was created. Accepting the invitation grants member permissions until approved.",
  "admin.apr.targetInvite": "Invitation {email} · initial role {role}",
  "admin.apr.awaitingInvite": "Approved · initial role not applied",
  "people.create.approval": "Approval request {code} was created. The account has member permissions until approved.",
  "people.create.make": "Create account",
  "people.create.err.name": "Enter a name.",
  "people.create.err.loginId": "The user ID needs 3–64 letters, digits, . _ or -.",
  "people.create.err.dup": "That user ID or email already exists.",
  "people.create.done.title": "Account created",
  "people.create.done.lead": "Give {name} the temporary password below. It’s shown only this once.",
  "people.create.done.loginId": "User ID {id}",
  "people.create.done.next": "At first sign-in they change the password, pick a recording level and connect their tools.",
  "people.create.done.google": "{name} signs in with the Google account {email}, then picks a recording level and connects their tools.",
  "people.create.toast": "Account created. It shows in the People tab.",
  "people.inv.emailHintPlain": "Only emails in the company’s allowed domains can be invited.",
  "people.inv.err.domainPlain": "That email isn’t in an allowed domain. Invite a company email.",
  "people.inv.resent.title": "New invite code ready",
  "people.bulk.skipped": "Skipped {n|person|people}.",
  "people.role.approvals": "Approval requests {codes}",
  "people.role.loadErr": "Couldn’t load the roles you can give.",
  "people.role.noRoles": "No role fits within your own permissions.",
  "people.role.previewLoading": "Checking how it applies…",
  "people.role.teamsDefault": "Manager and delegated-admin roles apply to each person’s current team.",
  "people.undo.sub": "You can undo for {s|second|seconds}",
  "people.undo.done": "Undone. Everything is back as it was.",
  "people.undo.expired": "The time to undo has passed.",
  "people.err.failed": "The change didn’t go through. Try again shortly.",
  "people.err.code": "(error {code})",
  "people.err.forbidden": "Your role can’t do this.",
  "people.err.notFound": "Not found — it may have changed already.",
  "people.err.conflict": "This clashed with another change. Refresh and try again.",
  "people.err.invalid": "Check the values you entered.",
  "people.err.approvalPending": "A request is already waiting for approval. Handle it in Admin → Roles & permissions → Pending approvals.",
  "people.err.teamsRequired": "Pick the teams it applies to.",
  "people.err.nameDup": "That name already exists.",
  "people.err.rate": "Too many requests. Try again shortly.",
  "people.err.mfa": "Handling roles needs multi-factor authentication (MFA). Use My records → Profile, alerts & display → [Set up MFA], then try again.",
  "people.err.pledge": "Handling roles needs the prohibited-use pledge first. Refresh the page, complete the pledge, then try again.",
  "people.d.authNoteTok": "By usage (tokens) · for Claude, each device’s last check",
  "people.d.sessions.btn": "End sign-ins",
  "people.d.sessions.title": "End all of this person’s sign-ins?",
  "people.d.sessions.body": "They’re signed out of every browser right away and can sign in again. Connected tools keep working.",
  "people.d.sessions.apply": "End sign-ins",
  "people.d.sessions.done": "Ended {n|sign-in|sign-ins}.",
  "people.d.reset.btn": "Temporary password",
  "people.d.reset.title": "Issue a new temporary password?",
  "people.d.reset.body": "The current password stops working right away and must be changed at the next sign-in. The new one is shown only once.",
  "people.d.reset.apply": "Issue",
  "people.d.grant.revoke": "Revoke",
  "people.d.grant.revokeTitle": "Revoke the “{role}” role?",
  "people.d.grant.revokeBody": "Permissions from this role end right away and their sign-in restarts. You can undo it for 10 seconds.",
  "people.d.grant.done": "Revoked the “{role}” role.",
  "people.d.grant.notFound": "Couldn’t find that grant. Revoke it on the Roles screen.",
  "people.issue.no_records": "No records received",
  "people.issue.helper_not_responding": "The PC helper isn’t responding",
  "people.issue.helper_backlog": "Records are waiting in the PC helper",
  "people.issue.collect_token_expired": "The connection token expired",
  "people.issue.collect_token_revoked": "The connection token was revoked",
  "people.issue.legacy_settings": "Old PoC settings remain",
  "people.issue.sends_more_than_consent": "Sends more than the consent allows",
  "people.issue.version_old": "The CLI version is old",
  "people.issue.version_checking": "The CLI version is being checked",
  "people.svc.st.active": "Active",
  "people.svc.st.suspended": "Suspended",
  "people.svc.st.expired": "Expired",
  "people.teams.hiddenTechPlain": "Team filter · small-group protection",
  "people.export.btn": "Export team totals",
  "people.export.title": "Export team totals",
  "people.export.format": "File format",
  "people.export.b1": "Only per-team totals — no names and no text.",
  "people.export.b2": "Teams under 3 people are merged and their head count reads “<3”.",
  "people.export.b3": "The export is kept in the access and change log.",
  "people.export.apply": "Export",
  "people.export.done": "Exported team totals.",
  "people.tree.q": "How are the teams organized?",
  "people.tree.tech": "Team structure · groups › teams · managers",
  "people.tree.sum": "{n|team|teams} in use · {g|group|groups} · {a} archived.",
  "people.tree.create": "Create team",
  "people.tree.edit": "Edit",
  "people.tree.managers": "Managers",
  "people.tree.archive": "Archive",
  "people.tree.group": "Group",
  "people.tree.archived": "Archived",
  "people.tree.members": "{n|person|people}",
  "people.tree.mgr": "Manager: {names}",
  "people.tree.noMgr": "No manager",
  "people.tree.empty": "No teams yet.",
  "people.tree.emptyNot": "Create teams to see usage by team and to set manager scope.",
  "people.teamForm.loadErr": "Could not load teams. Close this dialog and try again.",
  "people.teamForm.cycle": "A team cannot move under itself or one of its descendants.",
  "people.teamForm.depth": "This would create too many levels. Choose a parent nearer the top.",
  "people.teamForm.parentMembers": "Move the people out of this team before adding child teams.",
  "people.teamForm.parentInvites": "Cancel this team’s pending invitations first.",
  "people.archive.members": "Move the remaining people to another team first.",
  "people.archive.children": "Move or archive the child teams first.",
  "people.teamForm.archived": "An archived team cannot be edited.",
  "people.teamForm.groupMembers": "People must belong to a team, not a group.",
  "people.archive.b4": "Unused invitations and pending initial-role approvals for this team will also be canceled.",
  "people.tree.note": "Archiving or moving a team keeps past records with the team they had at the time.",
  "people.teamForm.editTitle": "Edit team",
  "people.teamForm.name": "Team name",
  "people.teamForm.nameHint": "Up to 40 characters.",
  "people.teamForm.parent": "Parent group",
  "people.teamForm.noParent": "None (top level)",
  "people.teamForm.group": "Make it a group",
  "people.teamForm.groupDesc": "A group holds teams; people belong to teams.",
  "people.teamForm.groupOn": "People can’t join a group. To add people, create a team under this group. Turn this off for a team people join directly.",
  "people.teamForm.groupPeople": "A team with people can’t become a group. Move its people to another team first.",
  "people.teamForm.groupOffDesc": "Turn off to make it a regular team people can join.",
  "people.teamForm.groupLocked": "Teams sit under it, so it can’t become a regular team. Move or archive those teams first.",
  "people.tree.groupEmpty": "No teams under it · to add people, use [Edit] to make it a regular team or create a team under it",
  "people.teamForm.err.name": "Enter a team name.",
  "people.teamForm.err.dup": "A team with that name already exists.",
  "people.teamForm.created": "Created “{team}”.",
  "people.teamForm.saved": "Team updated.",
  "people.archive.title": "Archive “{team}”?",
  "people.archive.b1": "It leaves team pickers and comparisons, and nobody new can join it.",
  "people.archive.b2": "Past records keep the team they had at the time.",
  "people.archive.b3": "Move the remaining people to another team first.",
  "people.archive.apply": "Archive",
  "people.archive.done": "Archived “{team}”.",
  "people.del.title": "Delete “{team}”?",
  "people.del.b1": "Only a team that was never used can be deleted (no membership, record, invitation or permission history, and no sub-teams).",
  "people.del.b2": "Archive a team with history instead. Archiving keeps past records’ team as it was.",
  "people.del.b3": "Deleting can’t be undone. It is kept in the access & change log.",
  "people.del.apply": "Delete",
  "people.del.done": "Deleted the “{team}” team.",
  "people.del.inUse": "This team has membership, record, invitation or permission history, so it can’t be deleted. Archive it instead.",
  "people.mgr.pending": "{code} is awaiting approval. Current managers stay in place until approval.",
  "people.mgr.expiry": "Expiry for newly assigned managers (optional)",
  "admin.apr.targetManagers": "Change managers of {team}",
  "admin.apr.managerChanges": "Add: {added} · Remove: {removed}. Applied together upon approval; assignments to other teams are retained.",
  "admin.grants.managerRefresh": "Reload the team list or resolve its pending approval first.",
  "people.mgr.title": "Assign managers",
  "people.mgr.pick": "People to make managers",
  "people.mgr.max": "Up to 10 people.",
  "people.mgr.none": "Nobody is in this team now.",
  "people.mgr.rule": "Assigning a manager grants the manager role and the team together. Managers see team totals and per-member sums, never members’ question or answer text.",
  "people.mgr.apply": "Assign",
  "people.mgr.done": "Updated the managers of “{team}”. Their sign-in restarts.",
  "people.tp.kicker": "Team",
  "people.tp.q": "How does this team use AI?",
  "people.tp.use.q": "How much does this team use?",
  "people.tp.use.tech": "Team totals · team at the time · no names",
  "people.tp.ratio": "CLI tools : API key calls",
  "people.tp.people.q": "Who is in this team?",
  "people.tp.mgmt.q": "Who looks after this team?",
  "people.tp.mgmt.tech": "Managers · parent group · teams below",
  "people.tp.sub": "Teams below",
  "people.tp.archived": "This team is archived. Only past records remain.",
  "people.tp.nf.title": "This team can’t be found",
  "people.tp.nf.desc": "It doesn’t exist or is outside what your role can see. Ask an admin if you need it.",
  "login.gate.loading": "Checking your first sign-in steps",
  "login.gate.errLoad": "The first sign-in steps couldn’t be loaded. Please try again shortly.",
  "login.gate.s.consent": "Agree to the notice",
  "login.gate.consent.title": "Read the recording notice and agree",
  "login.gate.consent.desc": "Read to the end what your AI usage records keep and who can see them, then choose how much to keep. You can change the recording level at any time.",
  "login.gate.consent.level": "How much to keep",
  "login.gate.consent.levelHint": "You start with ① basic info only. Levels above the company ceiling can’t be chosen.",
  "login.gate.consent.submit": "Agree and start",
  "login.gate.consent.done": "You agreed to the notice · recording up to {level}",
  "login.gate.consent.changed": "The notice just changed. Read the new notice to the end and agree again.",
  "login.gate.consent.errServer": "Your consent couldn’t be saved. Please try again shortly.",
  "login.gate.pledge.signPlain": "Signature — type your account name exactly",
  "login.gate.pledge.versionV": "Pledge {v} · you pledge again when your role or the pledge changes · pledges are kept in the access & change log",
  "login.gate.pledge.changed": "The pledge just changed. Read the new pledge and pledge again.",
  "login.gate.pledge.errServer": "Your pledge couldn’t be saved. Please try again shortly.",
  "login.gate.mfaSetup.titlePlain": "Set up multi-factor authentication (MFA)",
  "login.gate.mfa.keyLabel": "Setup key",
  "login.gate.mfa.qrLabel": "QR code for MFA setup",
  "login.gate.mfa.qrHint": "In your authenticator app, choose Add account → Scan a QR code, then scan this code.",
  "login.gate.mfa.apps": "You can use Google Authenticator, Microsoft Authenticator or another app that generates time-based one-time codes.",
  "login.gate.mfa.manualHint": "If you can't scan the QR code, enter the setup key below in your authenticator app.",
  "login.gate.mfa.keyHint": "This key is shown only once.",
  "login.gate.mfa.openApp": "On a phone? Open it in your authenticator app",
  "login.gate.mfa.errEnroll": "The setup key couldn’t be loaded. Please try again.",
  "login.invite.link": "Create an account with an invite code",
  "login.invite.kicker": "Invite code · create an account",
  "login.invite.title": "Create your invited account",
  "login.invite.desc": "Enter the invite code from your admin. A code works for 7 days.",
  "login.invite.descOk": "Invite confirmed. Choose a user ID, name and password to create the account.",
  "login.invite.code": "Invite code",
  "login.invite.codeHint": "It starts with AIAX- (e.g. AIAX-7KQ2-M4XA).",
  "login.invite.check": "Check invite",
  "login.invite.checking": "Checking…",
  "login.invite.invalid": "The invite code is wrong or has expired. Ask your admin for a new code.",
  "login.invite.okTitle": "Invite confirmed",
  "login.invite.email": "Email",
  "login.invite.team": "Team",
  "login.invite.expires": "Valid",
  "login.invite.until": "until {at}",
  "login.invite.loginIdHint": "3–64 letters, digits, . _ or -",
  "login.invite.submit": "Create account",
  "login.invite.busy": "Creating…",
  "login.invite.done": "Your account is ready. Sign in with the new account.",
  "login.invite.otherCode": "Use another code",
  "login.invite.back": "Back to sign-in",
  "login.invite.err.code": "Enter the whole invite code.",
  "login.invite.err.loginId": "The user ID must be 3–64 letters, digits, . _ or -.",
  "login.invite.err.taken": "That user ID is taken. Choose another one.",
  "login.invite.err.server": "The account couldn’t be created. Check what you entered and try again.",
  "me.st.loadError": "Your recording state couldn’t be loaded",
  "me.err.save": "Couldn’t save. Please try again shortly.",
  "me.err.prefs": "Couldn’t save the setting, so it was put back",
  "me.lv.overCap": "You can’t go above the company ceiling. The ceiling may have changed.",
  "me.n.changed": "The notice just changed. Read the new notice to the end and agree again.",
  "me.w.undoExpired": "The time to undo has passed. Agree again to restart recording.",
  "me.c.busy": "Making…",
  "me.c.fail": "Your copy couldn’t be made. Please try again shortly.",
  "me.c.readyPlain": "Your copy is ready",
  "me.d.noTitle": "No title",
  "me.d.auto": "automatic on withdrawal",
  "me.d.st.canceled": "Canceled · visible again",
  "me.d.st.waiting": "Waiting",
  "me.d.cancel": "Cancel request",
  "me.d.cancelTitle": "Cancel deletion request {code}?",
  "me.d.cancelLead": "Canceling shows those records in lists, details and totals again. The cancellation is kept in the access & change log.",
  "me.d.canceled": "Deletion request canceled · the records are visible again",
  "me.v.roleOnly": "Viewers are shown by role, not by name (questions: the privacy officer).",
  "me.v.more": "Show more",
  "me.v.conv": "Conversation #{no}",
  "me.a.loginGoogle": "Google account",
  "me.a.mfaEnroll": "Set up MFA",
  "me.a.mfaMissing": "Not set up · required",
  "me.a.mfaMissingD": "Your role has admin permissions, so an authenticator app must be set up.",
  "me.a.mfaOffD": "Not required for your role, but you can turn it on yourself.",
  "me.a.pledgeDone": "{v} · confirmed {date} · you confirm again when your role changes",
  "me.pw.open": "Change password",
  "me.pw.title": "Change password",
  "me.pw.lead": "Changing it signs you out everywhere except this browser.",
  "me.pw.current": "Current password",
  "me.pw.done": "Password changed",
  "me.pw.doneEnded": "Password changed · signed out of {n|other place|other places}",
  "me.pw.locked": "Too many wrong tries, so it’s locked for now. Please try again later.",
  "me.mfa.lead": "Add your METIS Hub account to your authenticator app, then enter its 6-digit code to finish setup.",
  "me.s.unknown": "Unknown device",
  "me.s.rule": "You sign in again after {idle} minutes unused or after {hours} hours.",
  "me.ds.tz": "Time zone",
  "me.ds.tzSeoul": "Korea time · follows the organization setting",
  "me.ds.tzOther": "Follows the organization time zone ({tz})",
  "me.ds.sampleNum": "Number example",
  "me.ds.sampleText": "Long text example",
  "me.ds.note": "Display settings are saved to your account, so other devices match. Language and theme change at once; check numbers, text size and wrapping in the preview below.",
  "redact.credential": "Credential",
  "redact.account": "Account number",
  "redact.blob": "Long data block",
  "audit.pseudonym": "User #{code}",
  "audit.actor.system": "System (automatic)",
  "audit.personPicked": "Selected person",
  "audit.where": "Where",
  "audit.err.save": "Couldn’t save. Please try again shortly.",
  "audit.err.verify": "The check couldn’t run. Please try again shortly.",
  "audit.kpi.never": "Not checked yet",
  "audit.kpi.neverHint": "No check has been recorded yet",
  "audit.integ.never": "No check has been recorded yet. Use [Check now] to compare the chain with the external anchor.",
  "audit.integ.autoAt": "Last automatic check {at}",
  "audit.integ.boxAnchor": "Doesn’t match the external anchor · the log may have changed after the {date} anchor",
  "audit.integ.sumAnchor": "The chain of {n} is unbroken, but it doesn’t match the {date} external anchor.",
  "audit.integ.firstBad": "First broken row",
  "audit.anchor.file": "Signed file",
  "audit.anchor.object_storage": "Write-once storage",
  "audit.anchor.email": "Mail archive",
  "audit.anchor.other": "External archive",
  "audit.bulkInCase": "Within an investigation · {from}–{to}",
  "audit.rep.month": "Month to review",
  "audit.rep.counts": "{n} (denied {d})",
  "audit.rep.n": "{n}",
  "audit.rep.reviewed": "Result for this month: {verdict} · {by} · {at}",
  "audit.csv.kicker": "{n|row|rows} to export",
  "audit.csv.identityD": "Real names need a reason category and a reason (10+ characters), and each person gets a log entry.",
  "audit.csv.pickCat": "Choose a reason category",
  "audit.csv.needCat": "Choose a reason category.",
  "audit.csv.needReason": "Write a reason of at least {min} characters.",
  "audit.csv.reasonHint": "At least {min} · now {n}",
  "audit.csv.rowLimit": "That’s more rows than one export allows. Narrow the period or the filters.",
  "audit.act.login.locked": "Sign-in locked",
  "audit.act.login.revoke": "Signed out another device",
  "audit.act.logout": "Sign-out",
  "audit.act.reauth": "Sign-in confirmed again",
  "audit.act.password.change": "Password changed",
  "audit.act.mfa.enroll": "MFA set up",
  "audit.act.pledge.ack": "Prohibited-use pledge",
  "audit.act.role.delete": "Role deleted",
  "audit.act.role.grant": "Role granted",
  "audit.act.role.revoke": "Role revoked",
  "audit.act.access.review": "Access review",
  "audit.act.case.create": "Investigation opened",
  "audit.act.case.defer_notice": "Notice deferred",
  "audit.act.person.create": "User added",
  "audit.act.person.disable": "User suspended",
  "audit.act.person.enable": "User restored",
  "audit.act.person.reset_password": "Temporary password issued",
  "audit.act.team.create": "Team added",
  "audit.act.team.update": "Team edited",
  "audit.act.team.archive": "Team archived",
  "audit.act.team.delete": "Team deleted",
  "audit.act.team.move": "Moved to another team",
  "audit.act.team.managers": "Managers set",
  "audit.act.invite.create": "Invite sent",
  "audit.act.invite.resend": "Invite resent",
  "audit.act.invite.cancel": "Invite canceled",
  "audit.act.invite.accept": "Joined by invite",
  "audit.act.sa.resume": "Service account resumed",
  "audit.act.apikey.create": "API key added",
  "audit.act.apikey.update": "API key edited",
  "audit.act.credential.create": "Company AI key added",
  "audit.act.credential.rotate": "Company AI key rotated",
  "audit.act.credential.revoke": "Company AI key revoked",
  "audit.act.token.issue": "Connection token issued",
  "audit.act.glossary.add": "Term added",
  "audit.act.glossary.edit": "Term edited",
  "audit.act.glossary.revert": "Term reverted",
  "audit.act.glossary.hide": "Term hidden",
  "audit.act.glossary.unhide": "Term shown again",
  "audit.act.glossary.linkcheck": "Glossary link check",
  "audit.act.change.undo": "Change undone",
  "audit.detail.reason_too_short": "Blocked: reason too short · at least {min} characters",
  "audit.detail.verify_ok": "Chain of {n} · intact",
  "audit.detail.verify_bad": "Chain of {n} · broken from #{seq}",
  "audit.detail.verify_anchor": "Chain of {n} · differs from the anchor",
  "audit.detail.anchor": "Compared with the {date} anchor",
  "audit.detail.review": "Monthly review {month} · {verdict}",
  "audit.detail.export_rows": "{rows} rows · {format}",
  "audit.detail.export_identity": "Real names included",
  "audit.detail.grant": "Granted {role}",
  "audit.detail.revoke": "Revoked {role}",
  "audit.detail.perm": "{role} · {perm} {sFrom} → {sTo}",
  "audit.detail.teams": "Teams {teams}",
  "audit.detail.until": "Until {date}",
  "audit.detail.undo": "Undone",
  "audit.detail.code": "{code}",
  "audit.detail.level": "Recording level {levelFrom} → {levelTo}",
  "audit.detail.pause": "Paused · until {until}",
  "audit.detail.resume": "Recording resumed",
  "audit.detail.withdraw": "Consent withdrawn · full deletion requested",
  "audit.detail.withdraw_undo": "Consent withdrawal undone",
  "audit.detail.agree": "Agreed to notice {notice}",
  "audit.detail.login_method": "{method}",
  "audit.detail.attempt": "Attempt {n}",
  "audit.detail.sessions_ended": "Ended {n|other login|other logins}",
  "audit.detail.notice": "Notice {from} → {to} · re-consent requested",
  "rail.problems": "{n|connection|connections} with errors",
  "bell.unread": "unread",
  "app.loading": "Loading your account",
  "access.chars": "{n|char|chars}",
  // Connect (SCR-08) — states and features only the server contract has (not in the mockup)
  "connect.person.pseudo": "User #{code}",
  "connect.alert.before.title": "You haven’t agreed to notice {v} yet",
  "connect.alert.before.desc": "Until you agree, records aren’t stored even when a tool is connected.",
  "connect.alert.paused": "Recording is paused",
  "connect.alert.withdrawn.title": "You withdrew consent, so records aren’t stored",
  "connect.alert.withdrawn.desc": "Agree again and records are stored from the next one. Your tool connections stay.",
  "connect.alert.resync.title": "Your recording level changed — get the CLI settings again",
  "connect.alert.resync.desc": "Until then the CLI sends with its old settings, and the server drops values outside your level before storing.",
  "connect.f.noLevel": "Not chosen",
  "connect.hist.empty": "No connection history yet.",
  "connect.issue.collect_token_expired": "The collect token expired, so records can’t be received",
  "connect.issue.collect_token_revoked": "The collect token was revoked, so records can’t be received",
  "connect.issue.helper_not_responding": "The PC helper isn’t responding",
  "connect.issue.helper_backlog": "{n|record|records} still waiting in the PC helper",
  "connect.issue.helper_backlog.desc": "They’re sent in order once it reconnects.",
  "connect.issue.no_records": "No records received for over {d|day|days}",
  "connect.issue.version_old": "The CLI version is older than the supported one",
  "connect.issue.version_checking": "A new CLI version — support is being checked",
  "connect.issue.version_checking.desc": "Basic info is stored with a “checking support” badge.",
  "connect.issue.generic": "Something is wrong with this connection",
  "connect.over.tool_output": "sending tool output (file contents, command output)",
  "connect.wz.token.expMax": "Up to {d|day|days} · we remind you {n|day|days} before",
  "connect.wz.token.expAt": "{date} ({d|day|days} left)",
  "connect.wz.test.needToken": "To wait for a test record, first get a collect token in step ③.",
  "connect.wz.test.stillWaiting": "Still waiting for the first record.",
  "connect.risk.need": "Tick the box to turn this on",
  "connect.risk4.title": "Record work details too?",
  "connect.risk4.body": "Commands, file paths and changes will be kept on the company server. If secrets end up in commands or tool input, redaction may miss them (it only catches known formats).",
  "connect.risk4.check": "I understand secrets may be included",
  "connect.risk4.ok": "Raise to ④",
  "connect.riskTool.title": "Turn on tool output?",
  "connect.riskTool.body": "Part of file contents and command output will be kept on the company server. Secrets or personal data may be included, and redaction only catches known formats.",
  "connect.riskTool.check": "I understand the risk",
  "connect.riskTool.ok": "Turn on",
  "connect.apply.noCommand": "These settings can’t be applied with one command. Choose Paste manually.",
  "connect.apply.noLines": "There are no lines to paste. Use the one-line command.",
  "connect.apply.download": "If you can’t paste the command, download the connection helper script and run it (it asks for your token when it runs):",
  "connect.snippet.line.codex_keep_other_otel": "# other keys in [otel] stay as they are",
  "connect.snippet.line.tool_output_off": "# tool output (file contents, command output) is not sent",
  "connect.snippet.line.backup_made": "# the original file is backed up before any change",
  "connect.snippet.note.codex_answers_unofficial": "Sending answers from Codex is an unofficial setting (0.162.1 or later).",
  "connect.snippet.note.codex_work_detail_filtered": "Codex always sends work details; the server filters them by recording level.",
  "connect.snippet.note.codex_keep_other_otel": "Other recording settings in the Codex settings file stay as they are.",
  "connect.snippet.note.metrics_untouched": "Settings used for OpenAI’s own statistics aren’t changed.",
  "connect.snippet.note.tool_output_off": "Tool output (file contents, command output) is turned off.",
  "connect.snippet.note.backup_made": "The original settings file is backed up before any change.",
  "connect.app.err.nameSlug": "Use 2–40 lowercase letters, digits or hyphens for the app name (e.g. support-summarizer).",
  "connect.app.models": "Allowed AI models",
  "connect.app.modelsNone": "No model of this AI company is switched on. A token would be refused on every call.",
  "connect.app.modelsAuto": "No need to pick models: the token may call what the company allows, and administrator changes apply at once.",
  "connect.models.q": "Which AI models can be used?",
  "connect.models.tech": "Gateway allowed models · per-person limits",
  "connect.models.sum": "{a} Anthropic and {o} OpenAI models can be used.",
  "connect.models.src": "Company model settings",
  "connect.models.readOnly": "Administrators decide the models. You don't pick them when creating a token; the limits below apply per person.",
  "connect.models.anyOn": "Model names that are not listed are allowed too.",
  "connect.models.none": "No model can be used.",
  "connect.models.col.model": "Model",
  "connect.models.col.limits": "Per-person limits",
  "connect.models.col.on": "On",
  "connect.models.col.daily": "Requests per day (per person)",
  "connect.models.col.monthly": "Tokens per month (per person)",
  "connect.models.dailyN": "{n} per day",
  "connect.models.monthlyN": "{n} tokens per month",
  "connect.models.noLimit": "No limit",
  "connect.models.badge.new": "New",
  "connect.models.badge.provider": "Fetched",
  "connect.models.badge.manual": "Added",
  "connect.models.follow": "Add the latest models automatically",
  "connect.models.followD": "New models in the built-in list are switched on when the Hub is updated. Models you switched off stay off.",
  "connect.models.any": "Allow model names that are not listed",
  "connect.models.anyD": "Any model can be called, not only the ones below. Costs are harder to control; switch on only when needed.",
  "connect.models.noneOn": "No {company} model is switched on. Saving like this refuses every call to this company's models.",
  "connect.models.allOn": "All on",
  "connect.models.allOff": "All off",
  "connect.models.discover": "Fetch the latest models with the company key",
  "connect.models.bulk": "Apply the same limits to every model that is on",
  "connect.models.bulkApply": "Apply to {n} models that are on",
  "connect.models.bulkHint": "Leave empty for no limit. Requests per day 1–1,000,000, tokens per month from 1,000. Days and months follow the company time zone.",
  "connect.models.addLabel": "Add model IDs in bulk",
  "connect.models.addPh": "One per line or comma separated (e.g. claude-opus-5-5, gpt-6.1-terra)",
  "connect.models.add": "Add",
  "connect.models.added": "Added {n} models. Save to apply.",
  "connect.models.found": "Fetched {n} new models from the AI company (off). Switch on the ones to use and save.",
  "connect.models.foundNone": "Nothing new to fetch: every model is already listed.",
  "connect.models.remove": "Remove from the list",
  "connect.models.save": "Save model settings",
  "connect.models.reset": "Undo changes",
  "connect.models.dirty": "There are unsaved changes.",
  "connect.models.saved": "Saved the model settings. They apply at once.",
  "connect.models.err.id": "Invalid model ID: {ids}",
  "connect.models.err.empty": "Enter the model IDs to add.",
  "connect.models.err.many": "Up to 200 models per AI company.",
  "connect.models.err.limit": "Check the limits: requests per day 1–1,000,000, tokens per month 1,000–100,000,000,000.",
  "connect.models.err.noKey": "This AI company has no company-wide gateway key. Register one in the company key vault below first.",
  "connect.models.err.keyRejected": "The AI company rejected the company key. Check it in the company key vault.",
  "connect.models.err.provider": "Couldn't get the AI company's model list. Try again shortly.",
  "connect.err.modelPolicy": "Couldn't read the model settings. Tell an administrator.",
  "connect.keys.add": "Add key",
  "connect.keys.addTitle": "Add an API key",
  "connect.keys.addLead": "The key value isn’t taken. Record the key with the last 4 characters and key ID shown in the AI company’s console.",
  "connect.keys.edit": "Edit",
  "connect.keys.editTitle": "Edit key {alias}",
  "connect.keys.save": "Save",
  "connect.keys.created": "API key added to the registry",
  "connect.keys.updated": "Key details updated",
  "connect.keys.err": "Check the alias (1–40 characters) and the last 4 characters.",
  "connect.keys.last4Hint": "Don’t enter the whole key — only its last 4 characters.",
  "connect.keys.noOwner": "Not set",
  "connect.keys.noTeam": "No team",
  "connect.keys.viaGateway": "Used by the company gateway",
  "connect.keys.inOrgReport": "Appears in the organization report",
  "connect.cred.q": "Which keys are in the company key vault?",
  "connect.cred.tech": "Company key vault · envelope-encrypted · only the last 4 shown",
  "connect.cred.sum": "{a} of {n} keys in use.",
  "connect.cred.note": "The gateway picks the most specific key: person > team > company. Key values are never shown again.",
  "connect.cred.emptyWhat": "No company keys stored.",
  "connect.cred.emptyNot": "Without a company key the gateway can’t call AI.",
  "connect.cred.add": "Add company key",
  "connect.cred.addTitle": "Add a company key",
  "connect.cred.addLead": "Paste the key from the AI company’s console. It’s encrypted and only its last 4 characters are kept.",
  "connect.cred.secret": "Key value",
  "connect.cred.err": "Check the alias (1–40 characters), the key value (8+ characters) and who it applies to.",
  "connect.cred.created": "Company key stored",
  "connect.cred.rotated": "Switched to the new key",
  "connect.cred.rotateDesc": "Enter the new key to use it instead of the current one. Key values are never shown again.",
  "connect.cred.revoke": "Revoke",
  "connect.cred.revokeTitle": "Revoke key {alias}?",
  "connect.cred.revokeBody": "Gateway calls that used this key pick another key from the next request, or fail.",
  "connect.cred.revoked": "Company key revoked",
  "connect.cred.col.scope": "Applies to",
  "connect.cred.col.purpose": "Used for",
  "connect.cred.col.changed": "Added / rotated",
  "connect.cred.scope.org": "Whole company",
  "connect.cred.scope.team": "Team",
  "connect.cred.scope.user": "Person",
  "connect.cred.scopeHint": "The most specific key is used: person > team > company.",
  "connect.cred.purpose.gateway": "Gateway company key",
  "connect.cred.purpose.admin": "Organization report key (Admin)",
  "connect.cred.src": "Company key vault",
  "connect.sup.supported": "Supported",
  "connect.sup.emptyWhat": "The support table hasn’t arrived yet.",
  "connect.sup.emptyNot": "That doesn’t mean nothing is supported. Try again shortly.",
  "connect.cov.srcAt": "Assessed {date} · updated along with the support table",
  "connect.cov.needLevel": "Recording level needed",
  "connect.cov.minVersion": "Minimum version",
  "connect.attr.q": "What is stored for each record attribute?",
  "connect.attr.tech": "Attribute details · stored (Yes/No) · where · level needed",
  "connect.attr.sum": "{y} of {n} attributes are stored.",
  "connect.attr.search": "Find an attribute",
  "connect.attr.searchPh": "Attribute or storage name",
  "connect.attr.f.all": "All",
  "connect.attr.yes": "Stored (Yes)",
  "connect.attr.no": "Not stored (No)",
  "connect.attr.col.name": "Attribute",
  "connect.attr.col.stored": "Stored",
  "connect.attr.col.where": "Stored in",
  "connect.attr.col.level": "Level needed",
  "connect.attr.notKept": "Not kept",
  "connect.attr.none": "No attribute matches",
  "connect.attr.emptyWhat": "The attribute table hasn’t arrived yet.",
  "connect.attr.emptyNot": "The item table above sums up what gets recorded.",
  "connect.err.tokenLimit": "You already have 10 active connection tokens. Disconnect one you don’t use and try again.",
  "connect.err.invalid": "Check the values you entered.",
  "connect.err.forbidden": "You don’t have permission to do this.",
  "connect.err.notFound": "It can’t be found. Reload the page.",
  "connect.err.conflict": "It changed elsewhere in the meantime. Reload and try again.",
  "connect.err.gatewayOff": "The company gateway is off. Please contact your admin.",
  "connect.err.gatewayConsent": "You can’t use the company gateway while consent is missing or recording is paused.",
  "connect.err.expiry": "Choose an expiry within 90 days.",
  "connect.err.network": "The server couldn’t be reached. Check your connection and try again.",
  "connect.err.rule": "It couldn’t be done because it breaks a rule.",
  "connect.err.generic": "It couldn’t be done. Try again shortly (error {code}).",
  // Glossary (SCR-09) — fields and states only the server contract has (not in the mockup)
  "glossary.e.sourceKo": "Source name (Korean document)",
  "glossary.e.sourceEn": "Source name (English document)",
  "glossary.e.expectedKo": "Expected page title (Korean document)",
  "glossary.e.expectedEn": "Expected page title (English document)",
  "glossary.e.manualRef": "Manual section",
  "glossary.e.manualRefHint": "Terms of this system link to a manual section instead of an outside document (e.g. /manual/#recording).",
  "glossary.e.savedQueued": "Saved · the external link shows once it passes the check",
  "glossary.err.stale": "Someone else changed this term in the meantime. Close it and open it again.",
  "glossary.err.conflict": "That can’t be done right now (terms linked to the label dictionary can’t be hidden).",
  "glossary.err.invalid": "Check the values you entered.",
  "glossary.err.forbidden": "You don’t have permission to edit the glossary.",
  "glossary.err.notFound": "The term can’t be found. Reload the page.",
  "glossary.err.network": "The server couldn’t be reached. Check your connection and try again.",
  "glossary.err.generic": "It couldn’t be done. Try again shortly (error {code}).",
  "glossary.foot.checkNone": "External link check: weekly · not run yet",
  "glossary.h.system": "System",
  "glossary.h.add": "Added",
  "glossary.hf.term": "Original term",
  "glossary.hf.plain": "Plain words",
  "glossary.hf.def": "Definition",
  "glossary.hf.example": "Example",
  "glossary.hf.links": "External addresses",
  "glossary.hf.manualRef": "Manual section",
  "glossary.lr.failed": "The link check didn’t finish. Try again shortly.",
  "glossary.lr.never": "not yet",
  "glossary.lr.why.http_error": "HTTP {code} came back",
  "glossary.lr.why.timeout": "No answer within the time limit",
  "glossary.lr.why.title_mismatch": "The page title isn’t the expected one",
  "glossary.lr.why.not_found_marker": "The page says it doesn’t exist",
  "glossary.lr.why.redirected": "It moved to another address — update it",
  "person.pseudo": "User #{code}",
  "notif.device_down.title": "A tool connection is down",
  "notif.device_down.titleTool": "Your {tool} connection is down",
  "notif.device_down.titleToolDays": "Your {tool} connection is down · no records for {days|day|days}",
  "notif.device_down.body": "Fine if you didn’t use it. If you did, check the connection.",
  "notif.collection_unknown.title": "New record fields were received",
  "notif.collection_unknown.body": "New record fields were received. Check their names and counts in collection status.",
  "notif.collection_gap.title": "There was a collection gap",
  "notif.collection_gap.titleMin": "Collection gap of {minutes} min",
  "notif.collection_gap.body": "The server received nothing for over 30 minutes during work hours. That window shows as “server didn’t receive”.",
  "notif.reconsent.title": "Please agree to the notice again",
  "notif.reconsent.titleVersion": "Please agree to notice {version}",
  "notif.reconsent.body": "New records aren’t stored until you agree again.",
  "notif.record_viewed.title": "Your record was viewed",
  "notif.record_viewed.body": "See who viewed it, when and why under “Who viewed my records”.",
  "notif.record_viewed.bodyCat": "Reason category: {reasonCategory} · details under “Who viewed my records”.",
  "notif.token_expiring.title": "A connection token expires soon",
  "notif.token_expiring.titleDays": "A connection token expires in {days|day|days}",
  "notif.token_expiring.body": "Get a new token under Connect before it expires.",
  "notif.budget_warning.title": "Close to the budget limit",
  "notif.budget_warning.body": "Check the limit and the estimated cost so far under Cost policy.",
  "notif.version_checking.title": "A new version is being checked",
  "notif.version_checking.titleVersion": "New version being checked: {tool} {version}",
  "notif.version_checking.body": "Basic info is stored; text and work details carry a “being checked” badge until review ends.",
  "notif.bulk_view.title": "Many texts were opened in a short time",
  "notif.bulk_view.titleCount": "Bulk content views: {count} in {minutes} min",
  "notif.bulk_view.body": "Check in the access & change log whether they were inside an investigation.",
  "notif.link_broken.title": "A glossary link needs checking",
  "notif.link_broken.titleCount": "{count|glossary link needs|glossary links need} checking",
  "notif.link_broken.body": "Review the check results in the glossary.",
  "notif.usage_spike.title": "Usage jumped above normal",
  "notif.usage_spike.body": "Check in Insights whether a batch was re-run.",
  "notif.team_update.title": "Your team’s usage changed",
  "notif.team_update.body": "See usage per teammate, by name, on Home.",
  "notif.policy_changed.title": "The recording policy changed",
  "notif.policy_changed.body": "See what changed under My records & settings.",
  "notif.deletion_processed.title": "Your deletion request was processed",
  "notif.deletion_processed.titleCount": "Your deletion request was processed · {count|conversation|conversations}",
  "notif.deletion_processed.body": "See the result under My records & settings.",
  "notif.approval_pending.title": "A request is waiting for approval",
  "notif.approval_pending.titleCount": "{count|request is|requests are} waiting for approval",
  "notif.approval_pending.body": "The requester and the approver must be different people (two-person approval).",
  "notif.grant_expiring.title": "A role grant ends soon",
  "notif.grant_expiring.titleDays": "A role grant ends in {days|day|days}",
  "notif.grant_expiring.body": "Ask an admin to extend it if you still need it.",
  "notif.audit_summary.title": "This week’s access & change summary is ready",
  "notif.audit_summary.titleCount": "{count|content view|content views} this week",
  "notif.audit_summary.body": "Check reasons and results in the access & change log.",
  // home (SCR-02) — wording the server contract needs beyond the mockup
  "home.cli.authTok": "Usage by payment: subscription {s} · API key {k} · unknown {u} tokens",
  "home.cli.authNoteTok": "By conversations: subscription {s} · API key {k} · unknown {u}",
  "home.cli.authNoteClaude": "for Claude, the method last confirmed on each device, so it’s an estimate",
  "home.issue.no_records": "No records received",
  "home.issue.no_recordsDays": "No records for {days|day|days}",
  "home.issue.helper_not_responding": "The PC helper isn’t responding",
  "home.issue.helper_backlog": "Records the PC helper hasn’t sent yet are piling up",
  "home.issue.collect_token_expired": "The collect token has expired",
  "home.issue.collect_token_revoked": "The collect token was revoked",
  "home.issue.legacy_settings": "Sending with old settings. Get the settings again",
  "home.issue.sends_more_than_consent": "Sending more than the agreed recording level (the extra isn’t stored)",
  "home.issue.version_old": "The CLI is older than the supported version",
  "home.issue.version_checking": "Support for this CLI version is being checked",
  "home.task.more": "and {n} more",
  "home.task.aprRole": "“{perm}” of the {role} role {from} → {to}",
  "home.task.kind.role_definition": "Request to change a role definition",
  "home.task.kind.role_grant": "Request to give a role",
  "home.task.kind.manager_team_content": "Request to let a manager see teammates’ text",
  "home.task.kind.investigation_case": "Request to start an investigation",
  "home.task.kind.notify_deferral": "Request to defer notices during an investigation",
  "home.task.rejectTitle": "Reject this request?",
  "home.task.rejectBody": "The requester sees the reason. Rejections are kept in the access & change log too.",
  "home.task.reasonApprove": "Reason for approving",
  "home.task.reasonReject": "Reason for rejecting (5+ characters)",
  "home.task.reasonEmpty": "Write a reason for approving.",
  "home.task.reasonShort": "Write at least 5 characters for the rejection reason.",
  "home.task.selfNo": "The requester can’t approve their own request (two-person approval).",
  "home.task.already": "This request has already been handled.",
  "home.task.failed": "That didn’t go through. Try again shortly.",
  "home.org.costPrice": "Price-table cost",
  "home.ops.stored": "Records stored today",
  "home.anom.bulkInCase": "Within an investigation · {from}–{to}",
  "home.gapReason.server_unreachable": "The server couldn’t be reached",
  "home.gapReason.no_receipt": "Nothing arrived at the server",
  "home.gapReason.helper_silent": "The PC helper didn’t respond",
  "home.gapReason.restore": "A restore was running",
  "home.gapReason.maintenance": "It was a maintenance window",
  "home.org.orgOkP": "{name} sync OK",
  "home.org.orgIssue": "{name}: {issue}",
  "home.org.orgOff": "{name}: not connected",
  "home.orgIssue.late": "sync is late",
  "home.orgIssue.auth": "the admin key failed to authenticate",
  "home.orgIssue.rate_limited": "hit the request limit",
  "home.orgIssue.no_admin_key": "no admin key",
  "home.aud.system": "System",
  "logs.view.label": "List view",
  "logs.view.list": "Conversations",
  "logs.view.events": "Single records",
  "logs.view.work": "Files·commands",
  "logs.ev.q": "What was recorded, one by one?",
  "logs.ev.tech": "{n|record|records} · original event name on each row",
  "logs.ev.sum": "{period}: {n|single record|single records}.",
  "logs.ev.col.record": "Conversation",
  "logs.ev.col.event": "Record",
  "logs.ev.col.detail": "Detail",
  "logs.wk.q": "Which files and commands did the AI handle?",
  "logs.wk.tech": "{n|item|items} · full paths and commands only for my records or under a grant",
  "logs.wk.sum": "{period}: {n|file or command|files and commands}.",
  "logs.wk.type": "Kind",
  "logs.wk.all": "All",
  "logs.wk.file": "Files",
  "logs.wk.command": "Commands",
  "logs.wk.col.type": "Kind",
  "logs.wk.col.label": "Label",
  "logs.wk.col.full": "Full path·command",
  "logs.wk.col.result": "Result",
  "logs.wk.ok": "Succeeded",
  "logs.wk.exit": "Exit code {n}",
  "logs.export.doneFile": "The CSV file was downloaded. The export was recorded too.",
  "logs.export.rowLimit": "Up to {max} rows can be exported at once. Narrow the conditions.",
  "logs.export.failed": "Couldn’t export. Try again in a moment.",
  "logs.title.anonNoChars": "Conversation #{no} · {n|question|questions}",
  "logs.act.viewDeniedAny": "{who} was refused viewing",
  "logs.act.export": "{who} exported",
  "logs.lock.deniedNote": "Refusals stay in the view history too. You can ask again with a new reason.",
  "logs.access.reasonLabel": "Reason ({n}+ characters)",
  "logs.access.tooShort": "Write a reason of {n}+ characters. A request with a short reason is recorded as refused.",
  "logs.access.reauthDesc": "After this check we won’t ask again for {min} minutes.",
  "logs.access.reauthGoogle": "You go to the Google sign-in page and come back to this conversation.",
  "logs.access.reauthWrong": "The password doesn’t match. Enter it again.",
  "logs.access.noContent": "This conversation has no stored text to open.",
  "logs.access.notNeeded": "You can already see this conversation. It opens without a grant.",
  "logs.access.failed": "The view grant didn’t go through. Try again in a moment.",
  "logs.more.delete": "Request deletion",
  "logs.more.deleteDesc": "Ask for this conversation’s text and identifiers to be deleted",
  "logs.delreq.title": "Request deletion of this conversation?",
  "logs.delreq.body": "Once requested, every role stops seeing this conversation right away and it’s handled within 7 days. Under a legal hold it’s deleted after the hold ends.",
  "logs.delreq.ok": "Request deletion",
  "logs.delreq.done": "Deletion requested. You’ll get a notification with the result.",
  "logs.delreq.failed": "Couldn’t send the deletion request. Try again in a moment.",
  "logs.decision.accept": "Allowed",
  "logs.decision.reject": "Rejected",
  "logs.decision.abort": "Stopped",
  "logs.decision.timed_out": "Timed out without an answer",
  "logs.err.rate_limit": "Rate limit (429)",
  "logs.err.server_error": "Server error (5xx)",
  "logs.err.auth": "Sign-in error",
  "logs.err.client_error": "Request error (4xx)",
  "logs.err.network": "Connection error",
  "logs.err.timeout": "Response timed out",
  "logs.err.refusal": "Refused by policy",
  "logs.err.interrupted": "Interrupted",
  "logs.err.policy_rejected": "Blocked by org policy",
  "effort.max": "Max",
  "glossary.lr.manual": "Internal manual",
  "glossary.lr.why.not_checked": "Detailed check results are not available yet",
  "admin.hl.glossary": "Glossary link checks",
  "admin.hl.glossaryProgress": "{done}/{total} checked · {bad} need attention",
  "admin.hl.glossaryDuration": "Took {seconds} seconds",
  "glossary.job.queued": "Waiting to check",
  "glossary.job.running": "Checking",
  "glossary.job.done": "Check finished",
  "glossary.job.failed": "Check failed",
};

export default app;
